export default {
  'ieo_home_h1': 'Initial Exchange Offering on Biconomy',
  'ieo_home_h2': 'Raise funds with us',
  'ieo_home_funds': 'Funds raised',
  'ieo_home_participants': 'Participants',
  'ieo_home_sale': 'Projects on sale',
  'ieo_home_new_project': 'New Project',
  'ieo_home_active': 'Active',
  'ieo_home_completed': 'Completed',
  'ieo_home_total_staked': 'total Staked ({coin})',
  'ieo_home_total_supply': 'Total Token Supply ({coin})',
  'ieo_home_sale_price': 'Sale price',
  'ieo_home_total_committed': 'total Committed ({coin})', 
  'ieo_what': 'What is an IEO ?',
  'ieo_home_desc_1': 'IEOs are initial exchange offerings, and it may well be the new ICOs — but what makes this method of fundraising different?',
  'ieo_home_desc_2': 'Initial Coin Offerings have lost their appeal in recent years — instead, many crypto projects have started raising funds using an Initial Exchange Offerings.',
  'ieo_home_desc_3': 'Known as an IEO for short, this is where a cryptocurrency exchange oversees the token sale. The benefits are clear: blockchain projects go through a comprehensive vetting process where their white paper is scrutinized, and their crowdfunding drive will also get publicity.',
  'ieo_home_desc_4': "Many investors tend to find IEO platforms more appealing because there's a greater level of due diligence than what's seen with an ICO.",

  'ieo_h1': 'INITIAL EXCHANGE OFFERING',
  'research_report': 'Research Report',
  'Purchased': 'Purchased',
  'Purchase': 'Purchase',
  'Finished': 'Finished',
  'project_introduction': 'Project Introduction',
  'issue_information': 'Issue Information',
  'token_proportions': 'Token Proportions',
  'limited_purchase_amount': 'Limited Purchase Amount',
  'i_need_to_spend': 'I need to spend',
  'purchase_amount_more': 'Purchase amount should be more than {asset}',
  'purchase_amount_less': 'Purchase amount should be less than {asset}',
  'purchased_successfully': 'Successfully purchased',
  'purchased_check': 'Check your asset in page Asset Management after purchasing successfully.',
  'the_purchase_term': 'The Purchase Term',
  'agree_to': 'Agree to',
  'release_schedule': 'Release Schedule',
  'countdown_start': 'Start the countdown',
  'countdown_end': 'End countdown',

  'Day': 'Day | Day | Days',
  'Hour': 'Hour | Hour | Hours',
  'Minute': 'Minute | Minute | Minutes',
  'Second': 'Second | Second | Seconds',
}